<template>

  <v-hover>
    <v-card
      slot-scope="{ hover }"
      :style="{ cursor: 'pointer'}"
      :class="`elevation-${hover ? 5 : 1}`"
      @click.native="$router.push(`/events/${event._id}`)"
    >
      <!-- <v-img src="https://randomuser.me/api/portraits/men/81.jpg" aspect-ratio="3"></v-img> -->
      <v-card-title primary-title>
        <div>
          <div class="headline">{{ event.title ? event.title : 'ללא כותרת' }}</div>
          <v-chip
            :color="eventType ? eventType.color : 'grey'"
            disabled
            text-color="white"
          >{{ eventType ? eventType.title : 'ללא סוג' }}</v-chip>
          <!-- <span class="grey--text">{{ eventType ? eventType.title : 'ללא סוג' }}</span> -->
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm4
          >
            <span class="grey--text">משך האירוע</span>
            <div class="display-5">{{ distanceInWordsStrict(event.startDate, new Date()) }}</div>
          </v-flex>
          <v-flex
            xs12
            sm4
          >
            <span class="grey--text">מנהל נוכחי</span>
            <div class="display-5">{{ fetchingManager ? 'טוען...' : currentManager }}</div>
          </v-flex>
          <v-flex
            xs12
            sm4
            v-if="currentAran"
          >
            <span class="grey--text">אר"ן</span>
            <div class="display-5">{{ currentAran }}</div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
import { distanceInWordsStrict } from "date-fns";
import { getApi } from "@/api";

export default {
  data: () => ({
    eventManagerId: null,
    fetchingManager: true
  }),

  computed: {
    event() {
      return this.$store.state.entities.events[this.eventId];
    },
    currentManager() {
      return this.$store.state.entities.users[this.eventManagerId]
        ? this.$store.state.entities.users[this.eventManagerId].name
        : "ללא מנהל";
    },
    currentAran() {
      if (this.event && this.event.aran) {
        const aran = this.$store.state.entities.arans[this.event.aran];
        return aran ? aran.name : null;
      }
      return null;
    },
    eventType() {
      let typeId = this.event.type ? this.event.type._id : null;
      if (typeId) {
        return this.$store.state.entities.eventTypes[typeId];
      }
    },
    eventManagerRoleId() {
      return Object.values(this.$store.state.entities.roles).find(item => {
        return item.key === "EVENT_MANAGER";
      })._id
    }
  },

  methods: {
    distanceInWordsStrict,
    fetch() {
      this.fetchingManager = true;
      getApi()
        .then(api => {
          let params = {
            q: JSON.stringify({
              event: this.eventId,
              role: this.eventManagerRoleId
            }),
            limit: 1,
            sort: "-endDate"
          };
          return api.get("duties", { params });
        })
        .then(({ data }) => {
          if (Array.isArray(data.results) && data.results.length) {
            this.eventManagerId = data.results[0].user;
            this.$store.commit('events/SET_EVENT_CURRENT_MANAGER', {
              eventId: this.eventId,
              managerId: this.eventManagerId
            })
          }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetchingManager = false;
        });
    }
  },

  mounted() {
    this.fetch();
  },

  props: ["eventId"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/events/active/ActiveEvent.vue